export enum PaymentMethodType {
    Card = 'card',
    ACH = 'ach',
    ACSS = 'acss',
    BACS = 'bacs',
    BECS = 'becs',
    SEPA = 'sepa_core',
    Phone = 'phone',
    Wire = 'wire',
    Check = 'check',
    Stablecoin = 'stablecoin',
}

export const BankPaymentMethods = [
    PaymentMethodType.ACH,
    PaymentMethodType.ACSS,
    PaymentMethodType.BACS,
    PaymentMethodType.BECS,
    PaymentMethodType.SEPA,
];
